import React from "react";

const defaultScope3Data = [
  {
    parameter: "Total Scope 3 emissions",
    unit: "Metric tonnes of CO2 equivalent",
    current: "",
    previous: "",
  },
  {
    parameter: "Total Scope 3 emissions per rupee of turnover",
    unit: "",
    current: "",
    previous: "",
  },
  {
    parameter: "Total Scope 3 emission intensity",
    unit: "",
    current: "",
    previous: "",
  },
];

const Scope3EmissionsTable = ({ scope3Data, setScope3Data }) => {
  const safeData =
    Array.isArray(scope3Data) && scope3Data.length === 3
      ? scope3Data
      : defaultScope3Data;

  const handleChange = (index, field, value) => {
    const updated = [...safeData];
    updated[index] = { ...updated[index], [field]: value };
    setScope3Data(updated);
  };

  const cell = {
    border: "1px solid #000",
    padding: "20px",
  };

  const paramCell = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    width: "35%",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    border: "1px solid #000",
    padding: "15px",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={header}>Parameter</th>
            <th style={header}>Unit</th>
            <th style={header}>
              FY _____
              <br />
              Current Financial Year
            </th>
            <th style={header}>
              FY _____
              <br />
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {safeData.map((row, index) => (
            <tr key={index}>
              <td style={paramCell}>
                <strong>{row.parameter}</strong>
                {index === 0 && <br />}
                {index === 0 && (
                  <small>
                    (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6,
                    NF3, if available)
                  </small>
                )}
                {index === 2 && (
                  <>
                    <br />
                    <small>
                      (optional – the relevant metric may be selected by the
                      entity)
                    </small>
                  </>
                )}
              </td>
              <td style={cell}>{row.unit}</td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Current FY"
                  value={row.current}
                  onChange={(e) =>
                    handleChange(index, "current", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Previous FY"
                  value={row.previous}
                  onChange={(e) =>
                    handleChange(index, "previous", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Scope3EmissionsTable;
